/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBarberManualAcceptClientInput } from "../../entities/models/BarberManualAcceptClientInput";
import { z } from "zod/v4";

export const modelsBarberManualAcceptClientInputSchema = z.object({
    "station_id": z.int()
    }) as unknown as z.ZodType<ModelsBarberManualAcceptClientInput>